import React from 'react';
import { Button } from '@material-ui/core';
import { mdiDownload } from '@mdi/js';
import Icon from '@mdi/react';
import styled from 'styled-components';
import { IconSize } from '../../../..';
import { FlexContainer } from './lab.styles';
const ControlsContainer = styled.div `
    margin-right: 1rem;
`;
export const LabControls = ({ isElectron, labReadyToLaunch, isInstalling, launchLab, downloadAndImport, virtualBoxInstalled }) => {
    return (React.createElement(ControlsContainer, null,
        React.createElement(FlexContainer, { "$hidden": !isElectron || labReadyToLaunch },
            React.createElement(Button, { variant: 'text', size: 'medium', color: 'primary', disabled: isInstalling || !virtualBoxInstalled, onClick: downloadAndImport, startIcon: React.createElement(Icon, { path: mdiDownload, size: IconSize.Medium }) }, "Quick Install")),
        React.createElement(FlexContainer, { "$hidden": !isElectron || !labReadyToLaunch },
            React.createElement(Button, { variant: 'text', size: 'medium', color: 'primary', disabled: !labReadyToLaunch, onClick: launchLab, startIcon: React.createElement(Icon, { path: mdiDownload, size: IconSize.Medium }) }, "Launch all machines"))));
};
//# sourceMappingURL=LabControls.js.map